<template>
    <div>
      <ValidationProvider :rules="required ? 'required' : ''" v-slot="{ errors }">
        <label :for="refName">{{ inputLabel }}</label>
        <multiselect
            :ref="refName"
            :show-labels="showLabels" 
            :value="value"
            @input="$emit('input', $event)" 
            :label="optionLabel" 
            :options="options" 
            :placeholder="placeholder" 
            :allow-empty="allowEmpty" 
            :track-by="trackByField"
            :preselect-first="preselectFirst"
            :custom-label="customLabel"
        >
            <template slot="singleLabel" slot-scope="{ option }">
                {{ option[optionLabel] }}
            </template>
            <span slot="noResult" class="text-danger">{{ noResultText }}</span>
        </multiselect>
        <span class="required small text-danger" v-if="required && errors[0]">&nbsp;&nbsp;&nbsp;{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </template>
  
  <script>
  import Multiselect from 'vue-multiselect';
  
  export default {
    components: {
      Multiselect
    },
    props: {
      refName: {
        type: String,
        default: ''
      },
      value: {
        type: [String, Object, Array, Number],
        default: ''
      },
      inputLabel: {
        type: String,
        default: ''
      },
      showLabels: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: () => []
      },
      placeholder: {
        type: String,
        default: 'Sélectionner'
      },
      allowEmpty: {
        type: Boolean,
        default: false
      },
      trackByField: {
        type: String,
      },
      noResultText: {
        type: String,
        default: 'Aucun élément trouvé.'
      },
      required: {
          type: Boolean,
          default: false
      },
      optionLabel: {
          type: String,
          default: ''
      },
      preselectFirst: {
        type: Boolean,
        default: false
      },
      customLabel: {
        type: Function,
      }
    },
  };
  </script>
  